import { apiService } from './index';
import { FinalCausality } from '../shared/types/typifications/finalCausality';

export const asyncCreateFinalCausality = async (
    finalCausality: FinalCausality
): Promise<FinalCausality | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FinalCausality;
        } = await apiService.post('/api/param/final-causality', finalCausality);

        return data;
    } catch (error) {}
};

export const asyncUpdateFinalCausality = async (
    id: string,
    finalCausality: FinalCausality
): Promise<FinalCausality | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FinalCausality;
        } = await apiService.patch(
            `/api/param/final-causality/${id}`,
            finalCausality
        );

        return data;
    } catch (error) {}
};
